import { Theme } from "@mui/material";
import Avatar, { AvatarProps } from "@mui/material/Avatar";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import colorsStyle from "assets/jss/mui-extras/colorsStyle";
import classNames from "classnames";
import { MuiColors } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";

const styles = (theme: Theme) => createStyles({
    ...colorsStyle(theme),
    small: {
        width: 22,
        height: 22
    },
    large: {
        width: 64,
        height: 64
    },
    border: {
        borderWidth: 1,
        borderStyle: "solid"
    },
    space: {
        marginRight: theme.spacing(1)
    }
});

interface IProps {
    color?: MuiColors,
    backgroundColor?: MuiColors,
    borderColor?: MuiColors,
    size?: "small" | "large";
}

type Props = IProps & AvatarProps & WithStyles<typeof styles>;


const MuiAvatar: React.FC<Props> = (props) => {
    const { classes, className, color, backgroundColor, borderColor, children, size, ...rest } = props;

    const cls = classNames({
        [classes[color]]: color != null,
        [classes["bg_" + backgroundColor]]: backgroundColor,
        [classes["bc_" + borderColor]]: borderColor,
        [classes.border]: borderColor,
        [classes[size]]: size != null,
        [classes.space]: true,
        [className]: className !== undefined,
    });

    return <Avatar {...rest} className={cls}>{children}</Avatar>;
};

export default withStyles(styles)(MuiAvatar);